import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgendasService {

  public currentUser = JSON.parse( sessionStorage.getItem( 'currentUser' ));

  private agendaDataSubject = new BehaviorSubject({});
  agendaData = this.agendaDataSubject.asObservable();

  constructor(private http: HttpClient) {}

  updateDataAgenda(data: any): void {
    this.agendaDataSubject.next(data);
  }

  private buildUrlApi(method: string): string {
    return `${environment.apiUrl}` + method;
  }

  getCurrentUserModelId(): number {
    return JSON.parse(sessionStorage.getItem('currentUser')).modelId;
  }

   /**
   * Método encargado de consultar al API las card de agendas
   */
   getCardAgendas(campo:string): Observable<any> {
    const agendasUrl = this.buildUrlApi('agenda/find');
    const request = {
      modelId: this.getCurrentUserModelId(),
      filtros: [{
        campo: campo,
        valor:"true"}]
    };
    return this.http.post<any[]>(agendasUrl, request, { observe: 'response' });
  }

  getSingleAgendaData(id: number): Observable<any> {
    let examenDataURL = '';
    if (id) {
      examenDataURL = this.buildUrlApi('agenda/find/' + id);
    } else if (window.location.href.includes('editar')) {
      let examenIdFromURL = parseInt(window.location.pathname.split('/')[2]);
      examenDataURL = this.buildUrlApi('agenda/find/' + examenIdFromURL);
    }
    return this.http.get<any>(examenDataURL);
  }

  saveAgenda( request: any): Observable<any> {
      return this.http.post<any>( this.buildUrlApi("agenda/save"), request );
  }
}
